<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <span class="bootstrap-dialog-title">
      {{ modalLabel }}
    </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div class="row" [formGroup]="automationForm">
      <div class="col-12">
        <div class="form-group required" aria-required="true">
          <div class="services-form">
            <input type="text" name="name" placeholder="Name" formControlName="workflowName" />
            <label>Workflow name</label>
          </div>
          <div
            *ngIf="
              automationForm.get('workflowName')?.touched &&
              automationForm.get('workflowName')?.hasError('required')
            "
            class="error-messages"
          >
            Workflow name is required.
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group required">
          <div class="project-spacing selctstops02">
            <label *ngIf="automationForm.get('triggerType')?.value" class="sub-header-drpdown pb-2"
              >Trigger Type</label
            >
            <label
              *ngIf="!automationForm.get('triggerType')?.value"
              class="placeholder-sub-header pb-2"
              >Trigger Type</label
            >

            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #shareEmailList
              [items]="automationData.triggerList"
              [searchable]="false"
              bindLabel="name"
              [searchFn]="commonInputSearch"
              placeholder="Trigger type"
              formControlName="triggerType"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="shareEmailList.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div
            *ngIf="
              automationForm.controls['triggerType']?.touched &&
              automationForm.controls['triggerType']?.invalid
            "
            class="error-messages"
          >
            <small>Trigger type is required</small>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <div class="d-flex align-items-center">
            <label>Active:</label>
            <div class="form-check form-switch switch-custom ml">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckChecked"
                formControlName="isActive"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
